<template>
  <div class="mt-8">
    <v-row dense>
      <v-col cols="12" md="12">
        <div class="text-subtitle-1 font-weight-bold">Featured Profiles</div>
      </v-col>

      <v-col cols="12">
        <div v-if="isEditingMCEvent">
          Spotlight your event partner/sponsor by adding their details to
          display as a badge with a clickable url on your EventConnect link. All
          event attendees that opt in to your EventConnect link, will be able to
          easily see and interact with these badges.
          preferred order.
        </div>
        <div v-else>
          Spotlight your event partner/sponsor by adding their details to
          display as a badge with a clickable url on your EventConnect link. All
          event attendees that opt in to your EventConnect link, will be able to
          easily see and interact with these badges.
        </div>
      </v-col>
      <v-col cols="12" md="12">
        <v-btn
          outlined
          depressed
          color="primary"
          large
          :disabled="businessProfile.plan != 'evolve'"
          @click="handleAddSponsor"
          >+ Add a Featured Profile</v-btn
        >
      </v-col>
      <v-col cols="12" md="2" class="mt-5 d-inline">
        <v-select
          v-if="sponsorList.length>0"
          :items="promoterTypeItems"
          dense
          flat
          solo
          @change="handlePromoterTypeChange"
          v-model="selectedPromoterType"
          append-icon="mdi-chevron-down"
          item-text="text"
          item-value="value"
          menu-props="offset-y"
        ></v-select>
      </v-col>
      <v-col cols="12">
        <v-data-table :headers="headers" :items="sponsorList"  :items-per-page="8" @click:row="this.handleEditSponsor">

        <template v-slot:item.name="{ item }">

          <v-list-item class="pl-0">
            <v-sheet class="rounded-lg mr-2" v-if="item.logoURL">
              <v-img class="rounded-lg" width="51.03" height="33.75" max-width="51.03" max-height="33.75"
                     :src="item.logoURL">
              </v-img>
            </v-sheet>
            <div>
              {{ item.name }}
            </div>
          </v-list-item>


        </template>
        <template v-slot:item.website="{ item }">
          <div>
            {{ item.website }}
          </div>
        </template>
        <template v-slot:item.personincharge="{ item }">
          <div>
            {{ item.firstName + " " + item.lastName }}
          </div>
        </template>
        <template v-slot:item.status="{ item }">
          <div>
            {{ item.isReviewed ? "Joined" : "Pending" }}
          </div>
        </template>
        <template v-slot:item.representative="{ item }">
          <div>
            0
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <v-menu>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>
            <v-list nav>
              <v-list-item @click="handleEditSponsor(item)">
                <v-list-item-title>Edit</v-list-item-title>
              </v-list-item>
              <v-list-item @click="handleRemoveSponsor(item)">
                <v-list-item-title>Delete</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
        <!-- <v-row> -->
        <!-- <template> -->
        <!-- <div class="d-flex flex-wrap justify-space-between"> -->
<!--        <draggable
          v-model="currentEvent.sponsors"
          :animation="200"
          group="sponsors"
          :class="[
            drag ? 'cursor-grabbing' : '',
            'd-flex justify-space-between flex-wrap',
          ]"
          @start="drag = true"
          @end="handleDragEnd"
        >
          <template v-for="(sponsor, index) in currentEvent.sponsors">
            <v-sheet
              rounded="lg"
              outlined
              class="d-inline-flex justify-space-between mb-6 cursor-grabbing"
              width="48%"
              :key="`sponsor${index}`"
            >
              <img
                v-if="sponsor.logoURL != ''"
                :src="sponsor.logoURL"
                height="125"
                class="rounded-l-lg"
                width="189"
                contain
              />
              <v-sheet
                color="#E0E0E0"
                v-else
                height="125"
                width="189"
                class="rounded-l-lg d-flex justify-center"
                ><v-icon>mdi-image-outline</v-icon></v-sheet
              >
              <v-sheet
                class="d-flex justify-space-between align-start inner-rounded-r-lg"
                color="#f5f8fd"
                style="width: calc(100% - 189px)"
              >
                &lt;!&ndash;Start: Sponsors name and website&ndash;&gt;
                <v-sheet
                  class="d-flex flex-column justify-center align-start px-2"
                  height="100%"
                  width="80%"
                  color="#f5f8fd"
                >
                  <div
                    class="text-subtitle-2 d-inline-block text-truncate"
                    style="width: 100%"
                  >
                    <div class="d-inline mr-1">{{ sponsor.name }}</div>
                    <v-chip
                      class="orange&#45;&#45;text orange lighten-5 font-weight-bold"
                      v-if="!sponsor.isReviewed && isEditingMCEvent"
                      label
                      small
                      >Pending</v-chip
                    >
                  </div>
                  <div
                    class="text-body-1 d-inline-block text-truncate"
                    style="width: 100%"
                  >
                    {{ sponsor.website }}
                  </div>
                </v-sheet>
                &lt;!&ndash;End: Sponsors name and website&ndash;&gt;
                <v-menu offset-y transition="slide-y-transition" bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn fab text small v-on="on" v-bind="attrs"
                      ><v-icon>mdi-dots-horizontal</v-icon></v-btn
                    ></template
                  >
                  <v-list>
                    <v-list-item @click="handleEditSponsor(sponsor)">
                      <v-list-item-title>Edit information</v-list-item-title>
                    </v-list-item>
                    &lt;!&ndash; <v-list-item
                      @click="showSponsorsContactDetails(sponsor)"
                      v-if="isEditingMCEvent"
                    >
                      <v-list-item-title
                        >View contact details</v-list-item-title
                      >
                    </v-list-item> &ndash;&gt;
                    &lt;!&ndash; <v-list-item
                      @click="handleResendInvitationToSponsor(sponsor)"
                      v-if="!sponsor.isReviewed && isEditingMCEvent"
                    >
                      <v-list-item-title>Resend invitation</v-list-item-title>
                    </v-list-item> &ndash;&gt;
                    <v-list-item @click="handleRemoveSponsor(sponsor)">
                      <v-list-item-title>Remove sponsor</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-sheet>
            </v-sheet>
          </template>
        </draggable>
     --> </v-col>
    </v-row>
    <v-dialog
      v-model="showAddEditSponsorDialog"
      v-if="currentSponsor != null"
      width="600"
      persistent
      scrollable
    >
      <AddEditSponsorDetails
        :event="this.selectedEvent"
        :isEditingSponsor="isEditMode"
        :sponsor="currentSponsor"
        :isEditingMCEvent="isEditingMCEvent"
        @close="handleCloseAddEditSponsorDialog"
        @sponsor-added="handleSponsorAdded"
        :eventCategory="eventCategory"
        :is-first-sponsor="sponsorList.length==0"
      />
    </v-dialog>

    <ConfirmationDialog
      :show="showConfirmationDialog"
      title="Remove sponsor?"
      content="Are you sure you want to remove this sponsor? All information related to this sponsor will be deleted."
      @click="removeSponsor"
      @closeDialog="showConfirmationDialog = false"
      buttonText="Remove sponsor"
    />

    <v-dialog
      v-model="showContactDetailsDialog"
      width="350"
      v-if="selectedSponsor != null"
    >
      <v-card>
        <v-card-title class="justify-space-between">
          Sponsor’s contact details
          <v-btn fab text small @click="showContactDetailsDialog = false"
            ><v-icon class="text-right">close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <div>{{ selectedSponsor.name }}</div>
            </v-col>
            <v-col cols="12">
              <div>
                {{ selectedSponsor.firstName + " " + selectedSponsor.lastName }}
              </div>
            </v-col>
            <v-col cols="12">
              <div>
                {{ selectedSponsor.email }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mx-3">
          <v-btn
            color="primary"
            depressed
            block
            large
            class="text-body-1 mb-4"
            @click="copyToClipboard(selectedSponsor.email)"
            >Copy Email</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showSponsorAddedDialog" width="500">
      <v-card>
        <v-card-actions class="justify-end">
          <div class="text-right">
            <v-btn fab text small @click="showSponsorAddedDialog = false" right
              ><v-icon>close</v-icon></v-btn
            >
          </div>
        </v-card-actions>

        <div class="text-center">
          <v-avatar color="#FDE1D6" size="70">
            <v-icon dark color="primary" large> mdi-check </v-icon>
          </v-avatar>
        </div>
        <v-card-title class="justify-center">{{
          sponsorAddedDialogTitle
        }}</v-card-title>
        <v-card-text>
          <div v-html="sponsorAddedDialogText"></div>
          <v-btn
            color="primary"
            depressed
            block
            class="text-body-1 mt-4"
            @click="showSponsorAddedDialog = false"
            >Close</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Sponsor from "@/models/Sponsor";
let uuid = require("uuid");
import ConfirmationDialog from "@/components/ConfirmationDialog";
import AddEditSponsorDetails from "@/components/MultiConnect/AddEditSponsorDetails";
import { mapGetters, mapActions } from "vuex";
import draggable from "vuedraggable";
import Utility from "@/shared/utility";
import {where} from "firebase/firestore";
import {deleteDocByName, getQueryByCollectionName} from "@/shared/firebase_utils";
export default {
  props: {
    isEditingMCEvent: { type: Boolean, default: false },
    eventCategory: { type: String, default: "multiConnect" },
  },
  data() {
    return {
      headers: [
        {
          text: "Business Name",
          value: "name",
          align: "start",
        },
        {
          text: "Website",
          value: "website",
          align: "start",
        },
        {
          text: "Person In Charge",
          value: "personincharge",
          align: "start",
        },
        {
          text: "Status",
          value: 'status',
          align: "start",
        },
        {
          text: "Representatives",
          value: "representative",
          align: "start",
        },
        { text: "Actions", value: "action", align: "start" },
      ],
      sponsorList: [],
      unsubscribeSponsorSnapshot: null,
      showAddEditSponsorDialog: false,
      currentSponsor: null,
      isEditMode: false,
      sponsorToBeRemoved: null,
      showConfirmationDialog: false,
      drag: false,
      showContactDetailsDialog: false,
      selectedSponsor: null,
      showSponsorAddedDialog: false,
      sponsorAddedDialogText: "",
      sponsorAddedDialogTitle: "",
      selectedEvent: null,
      promoterTypeItems: [
        { text: "Partners", value: "Partner" },
        { text: "Sponsors", value: "Sponsor" },
        { text: "Startups & Scaleups", value: "STARTUPS_AND_SCALE_UPS" },
      ],
      selectedPromoterType: "Partner",
    };
  },
  components: {
    ConfirmationDialog,
    AddEditSponsorDetails,
    draggable,
  },
  created() {
    this.refreshSponsorList();
  },
  destroyed() {
    // this.unsubscribeSponsorSnapshot();
  },
  mounted() {
    this.$emit("validatePage", "AddEditSponsors", this);
  },
  computed: {
    ...mapGetters(["currentEvent", "businessProfile", "currentSubEvent"]),
  },
  methods: {
    ...mapActions(["showSnackbar"]),
    refreshSponsorList() {
      if (this.eventCategory == "multiConnect")
        this.selectedEvent = this.currentEvent;
      else if (this.eventCategory == "subEvent")
        this.selectedEvent = this.currentSubEvent;
      if (this.selectedPromoterType == "STARTUPS_AND_SCALE_UPS")
        this.sponsorList = this.selectedEvent.featuredCompanies;
      else
        this.sponsorList = this.selectedEvent.sponsors;
    },
    handleAddSponsor() {
      //Set the edit mode for the sponsor
      this.isEditMode = false;

      //Create and set a sponsor
      this.currentSponsor = new Sponsor({ uid: uuid.v4() });
      this.showAddEditSponsorDialog = true;
    },

    async handleEditSponsor(sponsor) {
      if(sponsor.sponsorDocRef && sponsor.sponsorDocRef!="" && sponsor.sponsorDocRef!=null) {
        await this.$router.push({
          name: "editSponsor",
          params: {
            sponsorId: sponsor.sponsorDocRef,
            eventId: this.selectedEvent.id,
          },
          query: {
            promoterType: this.selectedPromoterType,
          },
        });
      } else {
        /// Create a sponsor doc

        const sponsorByUid = await getQueryByCollectionName("sponsors", where("uid", "==", sponsor.uid));
        if(sponsorByUid.empty) {

          const sponsorDoc = await sponsor.save();

          let index = this.selectedEvent.sponsors.findIndex(
              (spsr) => spsr.uid == sponsor.uid
          );
          sponsor.sponsorDocRef = sponsorDoc

          this.selectedEvent.sponsors.splice(index, 1, sponsor);
          this.$router.push({
                name: "editSponsor",
                params: {
                  sponsorId: sponsorByUid.docs[0].id,
                  eventId: this.selectedEvent.id,
                }
              }
          );
          //Save the event
          this.selectedEvent.save();
        } else {

          let index = this.selectedEvent.sponsors.findIndex(
              (spsr) => spsr.uid == sponsor.uid
          );
          sponsor.sponsorDocRef = sponsorByUid.docs[0].id

          this.selectedEvent.sponsors.splice(index, 1, sponsor);
          this.selectedEvent.save();

          console.log("Found sponsor by uid", sponsorByUid.docs[0].id);
          await this.$router.push({
                name: "editSponsor",
                params: {
                  sponsorId: sponsorByUid.docs[0].id,
                  eventId: this.selectedEvent.id,
                }
              }
          );
        }
      }
    },
    async removeSponsor() {
      this.currentEvent.sponsors = this.currentEvent.sponsors.filter((item) => {
        return item.uid != this.sponsorToBeRemoved.uid;
      });
      this.currentEvent.save();
      if(this.sponsorToBeRemoved.sponsorDocRef && this.sponsorToBeRemoved.sponsorDocRef!="" && this.sponsorToBeRemoved.sponsorDocRef!=null) {
        await deleteDocByName("sponsors", this.sponsorToBeRemoved.sponsorDocRef);
      }
      this.showConfirmationDialog = false;
      this.refreshSponsorList();
      await this.showSnackbar({ show: true, text: "Sponsor removed successfully!" });
    },
    handleRemoveSponsor(sponsor) {
      this.sponsorToBeRemoved = sponsor;
      this.showConfirmationDialog = true;
    },
    handleCloseAddEditSponsorDialog() {
      this.showAddEditSponsorDialog = false;
      this.refreshSponsorList();
      this.currentSponsor = null;
    },
    showSponsorsContactDetails(sponsor) {
      this.selectedSponsor = sponsor;
      this.showContactDetailsDialog = true;
    },
    async copyToClipboard(email) {
      Utility.copyToClipboard(email);
      this.showSnackbar({ show: true, text: "Copied to clipboard!" });
    },
    handleResendInvitationToSponsor(sponsor) {
      sponsor.sendInvitationEmail(
        this.currentEvent.id,
        this.currentEvent.name,
        this.currentEvent.hostName,
        "multiConnect"
      );
      this.showSnackbar({
        show: true,
        text: "Invitation resent successfully!",
      });
    },
    handleSponsorAdded() {
      //Close the AddEdit sponsor details dialog
      this.showAddEditSponsorDialog = false;
      this.currentSponsor = null;

      //START: COMMENTED FOR SOUTHSTART
      // if (!this.currentEvent.isCreationInProgress) {
      //   //Set the content for confirmation dialog for organizer
      //   this.sponsorAddedDialogTitle = promoterType + " Added";
      //   this.sponsorAddedDialogText = `<p>Great, we've sent an email to let your Event ${promoterType} know. </p> <p>They'll also be sent an invitation to join your Multi Connect link so they too can engage with attendees that may be interested in chatting/connecting with them.</p>`;
      //   this.showSponsorAddedDialog = true;
      // }
      //END: COMMENTED FOR SOUTHSTART
    },
    handleDragEnd() {
      this.drag = false;
      this.currentEvent.save();
    },
    validatePage() {
      return true;
    },
    handlePromoterTypeChange() {
      // if (this.isEditingMCEvent) {
      //   this.currentEvent.save();
      // }
      this.refreshSponsorList();
    },
  },
};
</script>
<style scoped>
.cursor-grab {
  cursor: grab !important;
}

.cursor-grabbing {
  cursor: grabbing !important;
}
</style>
